export default __webpack_public_path__ + "5e4a5f5ff463d0ed1d37725f200d98cc.png";